import { UnidadeGestoraResumida } from "@/types/ug/unidade-gestora-resumida";

const isNumeric = (string) => Number.isFinite(+string);
export class FiltrosUsuarios {
  texto?: string;
  situacao?: string | null;
  ug?: UnidadeGestoraResumida;

  constructor() {
    this.limpar();
  }

  limpar(): void {
    this.texto = undefined;
    this.situacao = null;
    this.ug = undefined;
  }

  toFormData(): FormData {
    const data = new FormData();
    if (this.texto) data.append("texto", this.texto);
    if (this.situacao) data.append("ativo", this.situacao);
    if (this.ug) data.append("codSagres", this.ug.Codigo || "");
    return data;
  }

  toQueryString(): string {
    const retorno: string[] = [];
    if (this.texto) {
      if (isNumeric(this.texto)) retorno.push("cpf=" + this.texto);
      else retorno.push("nome=" + this.texto);
    }
    if (this.situacao) {
      if (this.situacao === 'S') retorno.push("ativo=true");
      else if (this.situacao === 'N') retorno.push("ativo=false");
      else retorno.push("ativo=" + this.situacao);
    }
    if (this.ug) retorno.push("codSagres=" + this.ug.Codigo);
    return retorno.join("&");
  }
}
